export function request(parameters) {

    return (dispatch) => {
        dispatch({
            type: 'EVENTS_MINIMIZE_REQUEST',
            parameters
        });
    };
}
